import { defineStore } from 'pinia'

export const useGlobalStore = defineStore('global', {
  state: () => {
    return {
      isSidebarMinimized: false,
      signupPolicy: true,
      icpConfig: '',
    }
  },

  actions: {
    toggleSidebar() {
      this.isSidebarMinimized = !this.isSidebarMinimized
    },
    setSignupPolicy(policy: boolean) {
      this.signupPolicy = policy
    },
    setICPConfig(config: string) {
      this.icpConfig = config
    },
  },
})
